
export enum BlockType {
	TcsmResourceBlock = 'TcsmResourceBlock',
	TcsmActionBlock = 'TcsmActionBlock',
	TcsmNewsUpdateBlock = 'TCSMNewsUpdateBlock',
	TcsmLinkBlock = 'TCSMLinkBlock',
	TcsmVideoBlock = 'TcsmVideoBlock',
	TcsmDatesBlock = 'TcsmDatesBlock',
	TcsmParagraphBlock = 'TcsmParagraphBlock',
	TcsmInformationBlock = 'TcsmInformationBlock',
	TcsmButtonBlock = 'TcsmButtonBlock',
	TcsmAnnualEnrollmentMessageBlock = 'TcsmAnnualEnrollmentMessageBlock',
}

export enum AlignmentType {
	Right = 'Right',
	Left = 'Left',
	Center = 'Center',
}

export interface BaseBlockModel {
	blockType: string | BlockType;
}

export interface TcsmActionLink {
	linkText: string;
	linkUrl: string;
	externalLinkUrl: any;
	friendlyUrl: string;
	newWindow: boolean;
	rolesMatch: string;
}

export interface TcsmContentLink extends TcsmActionLink {
	// url: string,
	reactLink: boolean,
	isPdf: boolean,
	addAsterisk: boolean,
}
export type TcsmLinkBlock = BaseBlockModel & TcsmContentLink;

export interface TcsmResourceBlock extends BaseBlockModel {
	image: string;
	imageAltText: string;
	title: string;
	subtitle: string;
	description: string;
	links: TcsmContentLink[];
	viewAllText: string;
	viewAllLinkUrl: string;
}

export interface TcsmActionBlock extends BaseBlockModel {
	title: string;
	description: string;
	links: TcsmActionLink[];
}

export interface TcsmNewsUpdateBlock extends BaseBlockModel {
	date: string;
	title: string;
	summary: string;
	itemLink: TcsmLinkBlock;
	thumbnailImage: string;
	thumbnailImageAltText: string;
}

export interface TcsmVideoBlock extends BaseBlockModel {
	pageTitle: string;
	captionWysiwyg: string;
	thumbnail: string;
	hidePlayIcon: boolean;
	videoUrl: string;
	videoContentType: string;
	vimeoId: string;
	youTubeId: string;
}

export interface TcsmDatesBlock extends BaseBlockModel {
	pageTitle: string;
	description: string;
	pageSmallTitle: string;
	dateList: DateItem[];
}

export interface DateItem {
	fullDate: string;
	month: string;
	day: string;
	description: string;
}

export interface TcsmParagraphBlock extends BaseBlockModel {
	title: string;
	content: string;
}

export interface TcsmInformationBlock extends BaseBlockModel {
	content: string;
}

export interface TcsmButtonBlock extends BaseBlockModel {
	linkText: string;
	linkUrl: string;
	alignment: AlignmentType;
}

export interface TCSMAnnualEnrollmentMessage {
	annualEnrollmentStatus: string;
	message: string;
}

export interface TcsmAnnualEnrollmentMessageBlock extends BaseBlockModel {
	messages: TCSMAnnualEnrollmentMessage[];
}